import  { SESClient }  from  "@aws-sdk/client-ses";
// Set the AWS Region.
const REGION = "us-east-1"; //e.g. "us-east-1"
// Create SES service object.
const sesClient = new SESClient({ accessKeyId: "AKIAWRGGLE4V7WI6PO4U", secretAccessKey: "yAepUj21Xzz89B2244zxi1FrZNSqnSQkReQ5LVZN",region: REGION });
export  { sesClient };